import { Stack, TextField } from '@mui/material';

import Form from 'components/Form';

import { IFormRegister } from '../../type';

interface Props extends IFormRegister {
  disabled?: boolean;
  isTestMode?: boolean;
}

function FocusDar({ register, disabled, isTestMode }: Props) {
  const handlePreventEvent = (e: React.ClipboardEvent | React.MouseEvent) => {
    if (isTestMode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <Stack spacing={2}>
      <Form.Item label="포커스 Focus">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('focus')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="데이터 Data">
        <TextField
          fullWidth
          multiline
          minRows={4}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('data')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="활동 Action">
        <TextField
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('action')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="반응 Response">
        <TextField
          fullWidth
          multiline
          minRows={5}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('response')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>
    </Stack>
  );
}

export default FocusDar;
